import type { Locale } from "./domain";

export function money(value: number, locale: Locale): string {
  return new Intl.NumberFormat(locale === "ar" ? "ar-TN" : "fr-TN", {
    currency: "TND",
    currencyDisplay: "narrowSymbol",
    maximumFractionDigits: 3,
    minimumFractionDigits: 3,
    style: "currency",
  }).format(value / 1_000);
}

export function shortTime(value: string, locale: Locale): string {
  return new Intl.DateTimeFormat(locale === "ar" ? "ar-TN" : "fr-TN", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
}

export function relativeTime(value: string, locale: Locale): string {
  const minutes = Math.round((new Date(value).getTime() - Date.now()) / 60_000);
  return new Intl.RelativeTimeFormat(locale, { numeric: "auto" }).format(minutes, "minute");
}

export function shortId(value: string | null): string {
  return value ? `${value.slice(0, 8)}…${value.slice(-4)}` : "—";
}
